import { cn } from '@/lib/utils/cn';

// The design-token `--muted` sits almost on top of `--card` on the
// silver-blue palette (both ~96% lightness), so a plain `bg-muted`
// skeleton is nearly invisible. Bumped to 20% of muted-foreground so
// the pulse actually reads against every surface (page, card, tinted
// header, striped row).
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-muted-foreground/20', className)}
      {...props}
    />
  );
}
